import {useListView} from './core/ListViewProvider'
import {useQueryResponse, useQueryResponseData} from './core/QueryResponseProvider'
import {QUERIES} from '../../../../../_metronic/helpers'
import {fields} from './core/_models'
import {createBlog, deleteBlog, updateBlog} from './core/_requests'
import {KModal} from '../../../../../_component/modal/Modal'

export const ViewEditModal = () => {
  const {setItemIdForUpdate, itemIdForUpdate, setItemIdToView, itemIdToView} = useListView()
  const {refetch} = useQueryResponse()
  const blogs = useQueryResponseData()

  return (
    <KModal
      model={QUERIES.BLOG_LIST}
      title='Blog'
      setItemIdForUpdate={setItemIdForUpdate}
      itemIdForUpdate={itemIdForUpdate}
      setItemIdToView={setItemIdToView}
      itemIdToView={itemIdToView}
      fields={fields}
      data={blogs}
      update={updateBlog}
      create={createBlog}
      delete={deleteBlog}
      refetch={refetch}
    />
  )
}
